import { sanitizeStringForUrl } from '@grandvisionhq/utils';

const getBrandLink = (brandName, path)=>{
    const sanitizedBrand = sanitizeStringForUrl(brandName);
    const parts = path.split('/').filter((v)=>v !== ''
    );
    const isMultilingual = /[[a-z]{2}_[A-Z]{2}/g.test(parts[0]);
    const category = isMultilingual ? parts[1] : parts[0];
    const baseUrl = `/${isMultilingual ? `${parts[0]}/` : ''}${category}`;
    return `${baseUrl}/${encodeURIComponent(sanitizedBrand)}`;
};

export { getBrandLink };
//# sourceMappingURL=get-brand-link.js.map
